// import { Check, Zap, Sparkles, Rocket, Star, Crown } from "lucide-react";

// type Props = {
//   plans: any[];
//   type: "personal" | "company";
//   selected: string;
//   onSelect: (id: string) => void;
// };

// // Icon mapping based on plan name
// const getPlanIcon = (planName: string) => {
//   const name = planName?.toLowerCase() || "";
//   if (name.includes("starter") || name.includes("basic")) return Zap;
//   if (name.includes("plus") || name.includes("standard")) return Sparkles;
//   if (name.includes("pro") || name.includes("professional")) return Rocket;
//   if (name.includes("premium") || name.includes("business")) return Star;
//   if (name.includes("enterprise") || name.includes("ultimate")) return Crown;
//   return Zap;
// };

// // Badge mapping based on plan name
// const getPlanBadge = (planName: string) => {
//   const name = planName?.toLowerCase() || "";
//   if (name.includes("pro") || name.includes("professional")) return "Most Popular";
//   if (name.includes("plus") || name.includes("standard")) return "Best Value";
//   if (name.includes("starter") || name.includes("basic")) return null;
//   if (name.includes("enterprise") || name.includes("premium")) return "Premium";
//   return null;
// };

// // Description mapping
// const getPlanDescription = (plan: any) => {
//   if (plan.Description) return plan.Description;
  
//   const listings = plan.NumberOfListings === -1 ? "Unlimited" : plan.NumberOfListings;
//   const validity = `${plan.ValidityValue} ${plan.ValidityType}${plan.ValidityValue > 1 ? 's' : ''}`;
  
//   return `${listings} listings for ${validity}. Perfect for ${plan.CustomerType === 1 ? 'individual sellers' : 'companies'} who need ${listings} listing slots.`;
// };

// export default function SubscriptionStep({
//   plans,
//   type,
//   selected,
//   onSelect,
// }: Props) {
//   // If no plans, show message
//   if (!plans || plans.length === 0) {
//     return (
//       <div className="text-center py-12 text-[#717182]">
//         <p className="text-lg mb-2">No subscription plans available</p>
//         <p className="text-sm">Please check back later or contact support.</p>
//       </div>
//     );
//   }

//   // Check if free plan exists (Price = 0)
//   const hasFreePlan = plans.some((plan) => plan.Price === 0);
//   const paidPlans = plans.filter((plan) => plan.Price > 0);

//   return (
//     <div className="space-y-5">
//       {/* FREE PLAN */}
//       {hasFreePlan && (
//         <>
//           <div>
//             <div className="flex items-center gap-3 mb-3">
//               <div className="flex-1 h-px bg-[#E5E7EB]" />
//               <span className="text-xs text-[#717182] px-2 font-medium">Free Plan</span>
//               <div className="flex-1 h-px bg-[#E5E7EB]" />
//             </div>

//             <div className="grid grid-cols-1 gap-3">
//               {plans
//                 .filter((plan) => plan.Price === 0)
//                 .map((plan) => (
//                   <PlanCard
//                     key={plan.id}
//                     plan={plan}
//                     selected={selected}
//                     onSelect={onSelect}
//                     horizontal
//                   />
//                 ))}
//             </div>
//           </div>
//         </>
//       )}

//       {/* PAID PLANS */}
//       {paidPlans.length > 0 && (
//         <>
//           <div>
//             <div className="flex items-center gap-3 mb-3">
//               <div className="flex-1 h-px bg-[#E5E7EB]" />
//               <span className="text-xs text-[#717182] px-2 font-medium">
//                 {type === "personal" ? "Annual Subscription Plans" : "Company Plans"}
//               </span>
//               <div className="flex-1 h-px bg-[#E5E7EB]" />
//             </div>

//             <div className={type === "personal" ? "grid grid-cols-1 sm:grid-cols-2 gap-3" : "space-y-3"}>
//               {paidPlans.map((plan) => (
//                 <PlanCard
//                   key={plan.id}
//                   plan={plan}
//                   selected={selected}
//                   onSelect={onSelect}
//                   horizontal={type === "company"}
//                 />
//               ))}
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// type PlanCardProps = {
//   plan: any;
//   selected: string;
//   onSelect: (id: string) => void;
//   horizontal?: boolean;
// };

// function PlanCard({
//   plan,
//   selected,
//   onSelect,
//   horizontal = false,
// }: PlanCardProps) {
//   const isSelected = selected === plan.id;
//   const Icon = getPlanIcon(plan.SubscriptionName);
//   const badge = getPlanBadge(plan.SubscriptionName);
//   const description = getPlanDescription(plan);
  
//   const priceDisplay = plan.Price === 0 ? "Free" : `${plan.Price} MAD`;
//   const listingsDisplay = plan.NumberOfListings === -1 ? "♾️ Unlimited" : `${plan.NumberOfListings} Listings`;

//   return (
//     <div
//       onClick={() => onSelect(plan.id)}
//       className={`relative border-2 rounded-2xl p-5 cursor-pointer transition-all ${
//         isSelected
//           ? "border-[#1E6DFF] bg-[#1E6DFF]/5 shadow-md"
//           : "border-[#E5E7EB] hover:border-[#1E6DFF]/50 hover:shadow-sm"
//       } ${horizontal ? "flex items-center gap-4" : ""}`}
//     >
//       {/* Badge */}
//       {badge && (
//         <span className="absolute -top-2.5 left-4 text-xs px-2.5 py-0.5 bg-[#1E6DFF] text-white rounded-full font-medium">
//           {badge}
//         </span>
//       )}

//       <div
//         className={`flex items-center justify-between ${
//           horizontal ? "flex-1" : "mb-3"
//         }`}
//       >
//         <div className="flex items-center gap-3">
//           <div
//             className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-all ${
//               isSelected
//                 ? "bg-[#1E6DFF] text-white"
//                 : "bg-[#F5F7FA] text-[#717182]"
//             }`}
//           >
//             <Icon className="w-5 h-5" />
//           </div>

//           <div>
//             <p className="text-sm font-medium text-[#2D323A]">
//               {plan.SubscriptionName}
//             </p>

//             <div className="flex items-center gap-2 flex-wrap">
//               <p className="text-xs text-[#717182]">
//                 {listingsDisplay} / {plan.ValidityValue} {plan.ValidityType}
//                 {plan.ValidityValue > 1 ? 's' : ''}
//               </p>
//               {plan.IsTrial && (
//                 <span className="text-[10px] px-1.5 py-0.5 bg-green-100 text-green-700 rounded-full">
//                   Trial
//                 </span>
//               )}
//             </div>

//             <p className="text-sm font-semibold text-[#1E6DFF] mt-1">
//               {priceDisplay}
//               {plan.Price > 0 && (
//                 <span className="text-[10px] font-normal text-[#717182] ml-1">
//                   /{plan.ValidityType?.toLowerCase()}
//                 </span>
//               )}
//             </p>
//           </div>
//         </div>

//         <div
//           className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
//             isSelected
//               ? "border-[#1E6DFF] bg-[#1E6DFF]"
//               : "border-[#E5E7EB]"
//           }`}
//         >
//           {isSelected && <Check className="w-3 h-3 text-white" />}
//         </div>
//       </div>

//       {!horizontal && (
//         <p className="text-xs text-[#717182] mt-3 line-clamp-2">
//           {description}
//         </p>
//       )}
//     </div>
//   );
// }

// src/components/auth/SubscriptionStep.jsx
import { Check, Zap, Sparkles, Rocket, Star, Crown } from "lucide-react";
import { useTranslation } from 'react-i18next'; // 👈 Add

type Props = {
  plans: any[];
  type: "personal" | "company";
  selected: string;
  onSelect: (id: string) => void;
};

const getPlanIcon = (planName: string) => {
  const name = planName?.toLowerCase() || "";
  if (name.includes("starter") || name.includes("basic")) return Zap;
  if (name.includes("plus") || name.includes("standard")) return Sparkles;
  if (name.includes("pro") || name.includes("professional")) return Rocket;
  if (name.includes("premium") || name.includes("business")) return Star;
  if (name.includes("enterprise") || name.includes("ultimate")) return Crown;
  return Zap;
};

const getPlanBadge = (planName: string, t: any) => {
  const name = planName?.toLowerCase() || "";
  if (name.includes("pro") || name.includes("professional")) return t('register.subscription.most_popular');
  if (name.includes("plus") || name.includes("standard")) return t('register.subscription.best_value');
  if (name.includes("starter") || name.includes("basic")) return null;
  if (name.includes("enterprise") || name.includes("premium")) return t('register.subscription.premium');
  return null;
};

const getPlanDescription = (plan: any) => {
  if (plan.Description) return plan.Description;
  const listings = plan.NumberOfListings === -1 ? "Unlimited" : plan.NumberOfListings;
  const validity = `${plan.ValidityValue} ${plan.ValidityType}${plan.ValidityValue > 1 ? 's' : ''}`;
  return `${listings} listings for ${validity}. Perfect for ${plan.CustomerType === 1 ? 'individual sellers' : 'companies'} who need ${listings} listing slots.`;
};

export default function SubscriptionStep({
  plans,
  type,
  selected,
  onSelect,
}: Props) {
  const { t } = useTranslation('auth'); // 👈 Add

  if (!plans || plans.length === 0) {
    return (
      <div className="text-center py-12 text-[#717182]">
        <p className="text-lg mb-2">{t('register.subscription.no_plans')}</p>
        <p className="text-sm">{t('register.subscription.no_plans_desc')}</p>
      </div>
    );
  }

  const trialPlans = plans.filter((plan) => plan.IsTrial === true);
  const paidPlans = plans.filter(
    (plan) => plan.IsTrial === false && Number(plan.Price) > 0
  );

  return (
    <div className="space-y-5">
      {/* FREE PLAN */}
       {trialPlans.length > 0 && (
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="flex-1 h-px bg-[#E5E7EB]" />
            <span className="text-xs text-[#717182] px-2 font-medium">
              {t('register.subscription.free_plan')}
            </span>
            <div className="flex-1 h-px bg-[#E5E7EB]" />
          </div>
          <div className="grid grid-cols-1 gap-3">
            {trialPlans.map((plan) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              selected={selected}
              onSelect={onSelect}
              horizontal
              t={t}
            />
          ))}
          </div>
        </div>
      )}

      {/* PAID PLANS */}
      {paidPlans.length > 0 && (
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="flex-1 h-px bg-[#E5E7EB]" />
            <span className="text-xs text-[#717182] px-2 font-medium">
              {type === "personal" 
                ? t('register.subscription.personal_plans') 
                : t('register.subscription.company_plans')}
            </span>
            <div className="flex-1 h-px bg-[#E5E7EB]" />
          </div>
          <div className={type === "personal" ? "grid grid-cols-1 sm:grid-cols-2 gap-3" : "space-y-3"}>
            {paidPlans.map((plan) => (
              <PlanCard
                key={plan.id}
                plan={plan}
                selected={selected}
                onSelect={onSelect}
                horizontal={type === "company"}
                t={t}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

type PlanCardProps = {
  plan: any;
  selected: string;
  onSelect: (id: string) => void;
  horizontal?: boolean;
  t: any;
};

function PlanCard({
  plan,
  selected,
  onSelect,
  horizontal = false,
  t,
}: PlanCardProps) {
  const isSelected = selected === plan.id;
  const Icon = getPlanIcon(plan.SubscriptionName);
  const badge = getPlanBadge(plan.SubscriptionName, t);
  const description = getPlanDescription(plan);
  
  const price = Number(plan.Price);

const priceDisplay = price === 0 ? "Free" : `${price} MAD`;
  const listingsDisplay = plan.NumberOfListings === -1 
    ? t('register.subscription.listings_unlimited') 
    : `${plan.NumberOfListings} ${t('register.subscription.listings')}`;

  return (
    <div
      onClick={() => onSelect(plan.id)}
      className={`relative border-2 rounded-2xl p-5 cursor-pointer transition-all ${
        isSelected
          ? "border-[#1E6DFF] bg-[#1E6DFF]/5 shadow-md"
          : "border-[#E5E7EB] hover:border-[#1E6DFF]/50 hover:shadow-sm"
      } ${horizontal ? "flex items-center gap-4" : ""}`}
    >
      {badge && (
        <span className="absolute -top-2.5 left-4 text-xs px-2.5 py-0.5 bg-[#1E6DFF] text-white rounded-full font-medium">
          {badge}
        </span>
      )}

      <div className={`flex items-center justify-between ${horizontal ? "flex-1" : "mb-3"}`}>
        <div className="flex items-center gap-3">
          <div
            className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-all ${
              isSelected
                ? "bg-[#1E6DFF] text-white"
                : "bg-[#F5F7FA] text-[#717182]"
            }`}
          >
            <Icon className="w-5 h-5" />
          </div>

          <div>
            <p className="text-sm font-medium text-[#2D323A]">
              {plan.SubscriptionName}
            </p>
            <div className="flex items-center gap-2 flex-wrap">
              <p className="text-xs text-[#717182]">
                {listingsDisplay} / {plan.ValidityValue} {plan.ValidityType}
                {plan.ValidityValue > 1 ? 's' : ''}
              </p>
              {plan.IsTrial && (
                <span className="text-[10px] px-1.5 py-0.5 bg-green-100 text-green-700 rounded-full">
                  {t('register.subscription.trial')}
                </span>
              )}
            </div>
            <p className="text-sm font-semibold text-[#1E6DFF] mt-1">
              {priceDisplay}
              {price > 0 && (
                <span className="text-[10px] font-normal text-[#717182] ml-1">
                  {t('register.subscription.per_year')}
                </span>
              )}
            </p>
          </div>
        </div>

        <div
          className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
            isSelected
              ? "border-[#1E6DFF] bg-[#1E6DFF]"
              : "border-[#E5E7EB]"
          }`}
        >
          {isSelected && <Check className="w-3 h-3 text-white" />}
        </div>
      </div>

      {!horizontal && (
        <p className="text-xs text-[#717182] mt-3 line-clamp-2">
          {description}
        </p>
      )}
    </div>
  );
}